import { Component, Input, NgZone } from '@angular/core';
// import { Events } from 'ionic-angular';
import { User } from '../../providers/user';

/*
  Generated class for the AccountAvatar component.

  See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
  for more info on Angular 2 Components.
*/
@Component({
  selector: 'account-avatar',
  templateUrl: 'account-avatar.html'
})
export class AccountAvatarComponent {
  @Input() profile: any = {};
  @Input() hideName: boolean = false;
  @Input() photo64: string;
  blank: string = 'assets/img/user-blank.svg';
  constructor(public user: User, public zone: NgZone) {

  }
}



// WEBPACK FOOTER //
// ./src/components/account-avatar/account-avatar.ts